import { Link } from "react-router-dom";
import { MapPin, BadgeCheck, Sparkles } from "lucide-react";
import { StarRating } from "@/components/StarRating";

export function BusinessCard({ business }) {
  return (
    <Link
      to={`/business/${business.id}`}
      data-testid={`business-card-${business.id}`}
      className="group block bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm hover:shadow-lg hover:border-blue-300 hover:-translate-y-1 transition-all duration-200"
    >
      <div className="aspect-[16/10] bg-slate-100 overflow-hidden">
        {business.image_url ? (
          <img
            src={business.image_url}
            alt={business.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-slate-400">No image</div>
        )}
      </div>
      <div className="p-5">
        <div className="flex items-start justify-between gap-2 mb-2">
          <h3 className="text-lg font-semibold text-slate-900 group-hover:text-blue-700 transition-colors line-clamp-1">
            {business.name}
          </h3>
          <div className="flex gap-1 shrink-0">
            {business.featured && (
              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-amber-50 text-amber-700 border border-amber-200">
                <Sparkles className="h-3 w-3" /> Premium
              </span>
            )}
            {business.verified && (
              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200">
                <BadgeCheck className="h-3 w-3" /> Verified
              </span>
            )}
          </div>
        </div>
        {business.is_professional && business.professional_title && (
          <div className="text-xs uppercase tracking-widest text-blue-700 font-medium mb-1">
            {business.professional_title}
          </div>
        )}
        <p className="text-sm text-slate-600 line-clamp-2 mb-3">{business.description}</p>
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center gap-2 text-slate-500">
            <MapPin className="h-3.5 w-3.5" />
            <span>{business.city}, {business.state}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <StarRating value={business.rating_avg} size={14} />
            <span className="font-semibold text-slate-800">{business.rating_avg.toFixed(1)}</span>
            <span className="text-slate-400">({business.rating_count})</span>
          </div>
        </div>
      </div>
    </Link>
  );
}
